import React, { useEffect } from 'react';
import { Box, Card, Grid, Icon, IconButton, styled, Tooltip } from '@mui/material';
import { apiGetSumConsumptionByMonth } from '@services/ManageCustomers/CustomerServices';
import moment from 'moment';
import Loading from '@components/Loading';
import { showError } from '@components/notification';
import { formatCurrency, isNullOrEmpty } from '@utils/utils';

const StyledCard = styled(Card)(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '24px !important',
  background: theme.palette.background.paper,
  [theme.breakpoints.down('sm')]: { padding: '16px !important' },
  cursor: 'pointer'
}));

const ContentBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  '& small': { color: '#0051A9' },
  '& .icon': { opacity: 0.6, fontSize: '50px', color: '#0051A9' }
}));

const Heading = styled('h6')(({ theme }) => ({
  margin: 0,
  marginTop: '4px',
  fontSize: '16px',
  fontWeight: '500',
  color: '#0051A9'
}));
const TextValue = styled('h6')(({ theme }) => ({
  margin: 0,
  marginTop: '10px',
  fontSize: '20px',
  fontWeight: '500',
  color: '#0051A9'
}));

const ConsumptionCard = ({ selectedMonth, dataFilterAdvance, flagSearch, keyword }) => {
  const [data, setData] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const fetchData = async () => {
    try {
      setLoading(true);
      const fromDate = moment(selectedMonth + '-01');
      const response = await apiGetSumConsumptionByMonth({
        period: fromDate.format('YYYY-MM-DD'),
        keyword: keyword ?? undefined,
        ...dataFilterAdvance
      });
      setData(response?.data?.data);
    } catch (error) {
      setData([]);
      showError('Lỗi khi tính dữ liệu tiêu thụ theo tháng');
      console.error('Error fetching consumption data:', error);
    } finally {
      setLoading(false);
    }
  };
  // useEffect(() => {
  //   fetchData();
  // }, [flagSearch]);
  const cardList = [
    {
      name: 'Tổng tiêu thụ (m3)',
      total: !isNullOrEmpty(data?.total_consumption)
        ? formatCurrency(data?.total_consumption, 3)
        : 'N/A',
      icon: 'water_drop'
    },
    {
      name: 'Số lượng KH đủ dữ liệu tính',
      total: !isNullOrEmpty(data?.total_customers_with_consumption)
        ? data?.total_customers_with_consumption
        : 'N/A',
      icon: 'verified_user'
    },
    {
      name: 'Số lượng KH chưa đủ dữ liệu tính',
      total: !isNullOrEmpty(data?.total_customers_without_consumption)
        ? data?.total_customers_without_consumption
        : 'N/A',
      icon: 'remove_moderator'
    }
  ];

  return (
    <Grid container spacing={3}>
      {cardList.map((item, index) => (
        <Grid item xs={12} md={4} key={index}>
          <StyledCard elevation={4} loading={loading}>
            <ContentBox>
              <Icon className="icon">{item.icon}</Icon>
              <Box ml="18px">
                <Heading sty>{item.name}</Heading>
                <TextValue>{loading ? <Loading /> : item?.total}</TextValue>
              </Box>
            </ContentBox>
          </StyledCard>
        </Grid>
      ))}
    </Grid>
  );
};

export default ConsumptionCard;
